import { render, staticRenderFns } from "./ObjectExplorer.vue?vue&type=template&id=5bc7e4b6&scoped=true"
import script from "./ObjectExplorer.vue?vue&type=script&lang=js"
export * from "./ObjectExplorer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc7e4b6",
  null
  
)

export default component.exports